module.exports = __webpack_public_path__ + "media/images/icons/eye-regular-icon-d6e5b77905f6a7eaaa2111315455de84.svg";